// Redesign ("nova") routes. Every redesign page lives under the `/nova/` prefix (e.g.
// `/nova/drops`, `/nova/drop/[recordId]`), plus the standalone `/design-preview` playground.
// On these routes the legacy global chrome (Navigation / Footer) is hidden because each redesign
// page mounts its own RedesignNavbar / RedesignFooter. A new redesign page under `/nova/` is
// picked up automatically, no list to maintain.
//
// `pathname` is the Next.js route pattern (`router.pathname`), not the resolved URL.
export const isRedesignRoute = (pathname) => pathname.startsWith('/nova/') || pathname === '/design-preview';
// Full-screen, app-like redesign pages with their own bottom nav that should NOT render the global
// RedesignFooter (it just dangles below the form). The add-campaign wizard is one.
export const isRedesignFooterlessRoute = (pathname) => pathname === '/nova/add-campaign';
